import { PdsDocumentList } from '@client/components/market-pds/PdsDocumentList';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute } from '@tanstack/react-router';
import { FileStack } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/tools/pds-compare/pds-documents')({
    staticData: {
        presentation: 'fullPage',
        breadcrumb: {
            title: 'PDS documents',
        },
        featureFlag: 'enable-pds-comparison',
        permissions: [PERMISSIONS.MARKET_PDS_ACCESS],
        ui: {
            icon: FileStack,
            title: 'My PDS documents',
            subtitle: "Manage your organisation's uploaded PDS documents",
            widthVariant: 'fullWidth',
            menuDescription: 'Manage your PDS documents',
        },
        modules: ['pds-compare'],
    },
    component: OrgPdsList,
});

function OrgPdsList() {
    const { orgId } = Route.useParams();
    const navigate = useNavigate();

    return (
        <PdsDocumentList
            route={Route}
            scope="org"
            onOpenDocument={(id, event) =>
                navigate(
                    {
                        to: '/console/$orgId/tools/pds-compare/pds-documents/edit/$id',
                        params: { orgId, id: String(id) },
                    },
                    event,
                )
            }
        />
    );
}
